var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-tags"},[(_vm.tags & 1)?_c('div',{staticClass:"task-tag is-kaiting"},[_vm._v("开庭")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }